import { watch, type Ref } from 'vue';
import { createI18n } from 'vue-i18n';

import { appStorageController } from '@/shared/lib';

import { setSchemasLocale } from '../lib/schemas';
import { messages } from './messages';
import { AppLocale } from './types';

const locale: Ref<AppLocale> = appStorageController.locale;

const i18n = createI18n({
  legacy: false,
  globalInjection: false,
  locale: locale.value,
  fallbackLocale: AppLocale.RU,
  messages,
});

const localeOptions: Readonly<AppLocale[]> = [AppLocale.RU, AppLocale.EN] as const;
const intlLocaleByAppLocale: Readonly<Record<AppLocale, string>> = {
  [AppLocale.RU]: 'ru-RU',
  [AppLocale.EN]: 'en-GB',
} as const;

watch(
  locale,
  (newLocale: AppLocale): void => {
    i18n.global.locale.value = newLocale;
    setSchemasLocale(newLocale);
    document.documentElement.lang = newLocale;
  },
  { immediate: true },
);

const useLocale = () => ({ locale, localeOptions });

const getIntlLocale = (): string => intlLocaleByAppLocale[locale.value];

const translate = (key: string, params?: Record<string, unknown>): string =>
  params === undefined ? i18n.global.t(key) : i18n.global.t(key, params);

export { getIntlLocale, i18n, translate, useLocale };
